import prepareOptions from '../../prepareOptions';
import { TRUE } from './values';

export default prepareOptions([
  {
    value: TRUE,
    label: __('carDetails.equipmentGroups.metallicColor'),
    outerColor: 'metallic',
  },
]);
